module.exports = __webpack_public_path__ + "img/logo_full.d227926a.png";